export const sliderTokens = {
  slider: {
    track: {
      height: '6px',
      background: '{surface.300}'
    },
    tick: {
      background: '{surface.300}'
    },
    handle: {
      background: '{surface.0}',
      borderColor: '{surface.400}',
      shadow: '0px 1px 5px 0px rgba(53, 67, 88, 0.05)',
      dotColor: '{surface.600}',
      hoverDotColor: '{primary.color}',
      activeDotColor: '{primary.color}'
    }
  }
};

export type SliderTokens = typeof sliderTokens;
